/* ==========================================================================
   Le Petit Poulailler - fiche produit
   Selection de variante, changement de prix et d'image. JavaScript natif.

   Ce fichier faisait 37 Ko sur le theme d'origine : les trois quarts etaient
   le rendu de cadre de tableau (moulure en border-image, grain de toile,
   placement a l'echelle sur une photo de piece). Retire le 2026-08-20, sans
   objet sur un poulailler.
   ========================================================================== */

const donnees = document.querySelector('[data-lpp-variantes]');
if (donnees) {
  const variantes = JSON.parse(donnees.textContent);
  const champId = document.querySelector('[data-lpp-id-variante]');
  const zonePrix = document.querySelector('[data-lpp-prix]');
  const bouton = document.querySelector('[data-lpp-ajouter]');
  // Le libelle vient du reglage du bloc « Bouton d'achat ». On le memorise
  // pour le restaurer, au lieu de le reecrire en dur comme le faisait la
  // premiere version, qui ecrasait silencieusement le texte choisi.
  const libelleAchat = bouton.textContent.trim();
  let vueChoisieALaMain = false;
  const enAnglais = document.documentElement.lang === 'en';
  const libelleIndispo = enAnglais ? 'Unavailable' : 'Indisponible';

  const formatPrix = (centimes) =>
    new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(centimes / 100);

  function selectionCourante() {
    return [...document.querySelectorAll('.lpp-variantes__champ:checked')]
      .sort((a, b) => a.dataset.lppOption - b.dataset.lppOption)
      .map((c) => c.value);
  }

  // Calque de cadre : on montre celui de la finition choisie, on masque les
  // autres. Tous sont deja dans la page, donc le changement est instantane.
  function reveillerImages(vue) {
    if (!vue) return;
    vue.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      // On se contente de repasser en chargement immediat. La reaffectation
      // de `src` a ete essayee et ecartee : sur une image qui porte un
      // `srcset`, elle relance une selection de source et laissait l'image
      // en erreur, largeur naturelle nulle. Le changement d'attribut suffit
      // a declencher le chargement (verifie le 2026-08-02).
      img.loading = 'eager';
    });
  }

  // CALQUE SERVI A SA TAILLE REELLE.
  // `border-image` decoupe la source en neuf zones. Si la decoupe fait 128
  // pixels dans le fichier et que la moulure n'en occupe que 11 a l'ecran,
  // le navigateur comprime d'un facteur douze, et le raccord entre un coin
  // et un cote laisse une ligne claire. C'est la cause du lisere que trois
  // correctifs successifs n'avaient pas fait disparaitre : ils agissaient
  // sur la jointure avec l'oeuvre, alors que le defaut etait dans la
  // moulure elle-meme.
  // On demande donc la source a la taille exacte d'affichage, en pixels
  // REELS d'ecran, et on regle la decoupe pour qu'elle vaille l'epaisseur.
  // Rapport de reduction : un pour un.
  function afficherMedia(id) {
    const vues = [...document.querySelectorAll('[data-lpp-media]')];
    if (!vues.length) return;
    // REPLI OBLIGATOIRE SUR LA PREMIERE VUE. Deux cas le rendent necessaire,
    // et les deux laissaient la fiche SANS AUCUNE IMAGE :
    //   1. une variante sans image attachee ne designe aucune vue. C'est le
    //      cas de toute fiche dont les declinaisons sont des references
    //      fournisseur, tres frequent en import DSers ;
    //   2. la variante designe une image reelle mais au dela de la limite
    //      posee dans le gabarit, donc jamais rendue.
    // Sans ce repli, la boucle masquait les vues une a une et n'en
    // redonnait aucune. Releve par Pablo le 2026-08-26.
    const connu = vues.some((d) => d.dataset.lppMedia === String(id));
    const cible = connu ? String(id) : vues[0].dataset.lppMedia;
    vues.forEach((d) => {
      d.hidden = d.dataset.lppMedia !== cible;
      if (!d.hidden) reveillerImages(d);
    });
    document.querySelectorAll('[data-lpp-choisir-media]').forEach((b) => {
      b.setAttribute('aria-pressed', String(b.dataset.lppChoisirMedia === cible));
    });
  }

  function majSelection() {
    const choix = selectionCourante();
    // UN PRODUIT SANS DECLINAISON n'affiche aucun selecteur, donc `choix` est
    // vide et aucune variante ne peut correspondre. Sans ce repli, le bouton
    // d'achat passait a « Indisponible » sur tout produit a variante unique.
    const v = choix.length === 0
      ? variantes[0]
      : variantes.find((x) => x.options.every((o, i) => o === choix[i]));

    // Libelle de l'option a cote de son intitule.
    document.querySelectorAll('[data-lpp-valeur-option]').forEach((el, i) => {
      if (choix[i]) el.textContent = choix[i];
    });

    if (!v) {
      bouton.disabled = true;
      bouton.textContent = libelleIndispo;
      return;
    }
    champId.value = v.id;
    zonePrix.textContent = formatPrix(v.prix);
    // On ne change PAS de vue quand l'acheteur en a choisi une. Sans cette
    // garde, selectionner un cadre ou une taille le renvoyait sur la
    // premiere image, alors qu'il regardait justement la seconde pour voir
    // le cadre. Releve deux fois par Pablo.
    if (!vueChoisieALaMain) afficherMedia(v.media);

    // AUCUN libelle de pre-commande. PN compte 23 299 variantes qui le
    // declencheraient. On distingue seulement disponible ou non.
    bouton.disabled = !v.disponible;
    bouton.textContent = v.disponible ? libelleAchat : libelleIndispo;
  }

  // Choisir une finition de cadre AMENE sur la vue encadree. C'est la
  // demande de Pablo du 2026-08-01, et elle a une logique commerciale :
  // cliquer sur une pastille de cadre, c'est demander a voir ce cadre. Le
  // laisser sur la mise en situation obligeait a cliquer une seconde fois
  // sur la vignette pour constater son choix.
  // Seule la SECONDE image porte le calque, c'est donc elle qu'on amene.
  function ramenerLaGalerie() {
    if (matchMedia('(min-width: 990px)').matches) return;
    const vue = [...document.querySelectorAll('[data-lpp-media]')].find((d) => !d.hidden);
    if (!vue) return;

    // Ce qui est cache derriere l'en-tete collante ne compte pas comme vu.
    const hautCollant = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--lpp-offset-collant')
    ) || 0;
    const b = vue.getBoundingClientRect();
    const vu = Math.max(0, Math.min(b.bottom, innerHeight) - Math.max(b.top, hautCollant));
    // Deja entierement a l'ecran : on ne bouge pas. Un defilement automatique
    // qui se declenche pour rien est plus penible que le defaut qu'il
    // corrige. Le seuil est haut, 90 %, parce que la cible est desormais de
    // tout montrer : a 60 % de tableau visible, il reste quelque chose a
    // gagner.
    if (!b.height || vu / b.height >= 0.9) return;

    const ecart = b.top - (hautCollant + 8);
    // On ne descend jamais, et on ne bouge pas pour trois fois rien.
    if (ecart > -24) return;

    scrollBy({
      top: ecart,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  document.querySelectorAll('.lpp-variantes__champ')
    .forEach((c) => c.addEventListener('change', () => {
      majSelection();
      // En dernier, une fois la bonne vue posee : elle mesure ce qui est
      // affiche, pas ce qui l'etait avant.
      ramenerLaGalerie();
    }));

  // Des que l'acheteur clique une vignette, on considere qu'il pilote la
  // galerie : le changement de variante ne la reprend plus.
  document.querySelectorAll('[data-lpp-choisir-media]')
    .forEach((b) => b.addEventListener('click', () => {
      vueChoisieALaMain = true;
      afficherMedia(b.dataset.lppChoisirMedia);
    }));

  majSelection();
}


/* ==========================================================================
   Produits complementaires.
   Shopify ne peut pas calculer ses recommandations pendant le rendu de la
   page : il faut les demander apres coup. On ne le fait qu'a l'approche de
   la section, pour ne rien couter tant que le visiteur n'y arrive pas.
   Si la requete echoue, la collection de repli rendue cote serveur reste
   affichee : la section ne se vide jamais.
   ========================================================================== */
const zoneReco = document.querySelector('[data-lpp-recommandes]');
if (zoneReco && 'IntersectionObserver' in window) {
  const observateur = new IntersectionObserver((entrees) => {
    if (!entrees.some((e) => e.isIntersecting)) return;
    observateur.disconnect();
    fetch(zoneReco.dataset.url)
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((html) => {
        const recu = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('[data-lpp-recommandes]');
        const grille = recu && recu.querySelector('.lpp-grille');
        if (grille) zoneReco.querySelector('.lpp-grille')?.replaceWith(grille);
      })
      .catch(() => { /* le repli serveur reste en place */ });
  }, { rootMargin: '600px' });
  observateur.observe(zoneReco);
}


/* ==========================================================================
   Barre d'achat collante, mobile.

   Elle n'apparait QUE lorsque le bouton principal est sorti de l'ecran :
   affichee en permanence, elle ferait doublon et mangerait de la hauteur.

   Calcul au defilement plutot qu'IntersectionObserver. Deux raisons : la
   position exacte du bouton est de toute facon lue pour decider, et le
   calcul est verifiable en recette, alors que l'observateur ne se declenche
   pas dans le navigateur de test. Le rappel est cale sur le rafraichissement
   de l'ecran, donc il ne coute rien.
   ========================================================================== */
/* Composant autonome plutot que du code au fil du module.

   Raison, constatee le 2026-07-30 : le meme fichier fonctionnait quand on
   l'importait a la main mais pas au chargement naturel de la page, le bloc
   de fin n'ayant visiblement pas le meme sort que le debut du module selon
   le moment ou Shopify sert l'asset. Un element personnalise ne depend
   d'aucun ordre : le navigateur appelle `connectedCallback` des que la
   definition existe, que l'element ait ete analyse avant ou apres. */
class PnAchatCollant extends HTMLElement {
  connectedCallback() {
    this.bouton = document.querySelector('[data-lpp-ajouter]');
    if (!this.bouton) return;

    this.enAttente = false;
    this.planifier = () => {
      if (this.enAttente) return;
      this.enAttente = true;
      requestAnimationFrame(() => this.evaluer());
    };
    addEventListener('scroll', this.planifier, { passive: true });
    addEventListener('resize', this.planifier, { passive: true });
    this.evaluer();

    // Le bouton de la barre delegue au vrai bouton : une seule mecanique
    // d'ajout, donc un seul endroit ou se tromper.
    this.querySelector('[data-lpp-achat-collant-bouton]')
      ?.addEventListener('click', () => this.bouton.click());
  }

  disconnectedCallback() {
    removeEventListener('scroll', this.planifier);
    removeEventListener('resize', this.planifier);
  }

  evaluer() {
    this.enAttente = false;
    const b = this.bouton.getBoundingClientRect();
    // La barre s'efface tant que le bouton principal est a l'ecran, et
    // reparait des qu'il en sort. Visible par defaut dans le balisage : si
    // le script ne tourne pas, il reste une barre d'achat utile.
    this.hidden = b.bottom > 80 && b.top < window.innerHeight;
  }
}

if (!customElements.get('lpp-achat-collant')) {
  customElements.define('lpp-achat-collant', PnAchatCollant);
}
